<template>
  <section>
    <!-- Componentes externos -->
    <ReprogramarCronograma />
    <AprobarReprogramacionVacacion/>
    <RechazarReprogramacionVacacion/>
    <VerDetalle />
    <VerReporte/>
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Solicitud de vacación
    </h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template injectable de la cabecera de la tabla -->

          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
                color="warning"
                dark
                @click.native.stop="verReporte({},7)"
                slot="activator"
                ><v-icon dark>picture_as_pdf</v-icon> </v-btn
              >
              <span>Ver reporte</span>
            </v-tooltip>
          </template>
          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items" v-if="items.item.id_persona!=$storage.get('user').id_persona">
            <!-- Agregar las columnas que consideré necesarias -->
            <td class="text-xs-center">
              {{ items.item.secuencia }}
            </td>
            <td class="text-xs-center">{{ items.item.nombre }}</td>
            <td class="text-xs-center">{{ items.item.fecha_desde }}</td>
            <td class="text-xs-center">{{ items.item.fecha_hasta }}</td>
            <td class="text-xs-center">{{ items.item.total_dias }}</td>
            <td class="text-xs-center">{{ items.item.estado }}</td>
            <td>
              <!-- ver detalle-->

              <v-btn
                color="#3dca24"
                @click.prevent="verDetalle(items.item)"
                icon
                title="Ver detalle"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <!--  EJECUCION DE LA VACACION-->
              <v-btn
              v-if="items.item.estado=='Pendiente Aprob. Reprog'"
                color="#44deaa"
                @click.prevent="aprobarReprogramacion(items.item)"
                icon
                title="Enviar solicitud de uso de vacación"
              >
                <v-icon>send</v-icon>
              </v-btn>
              <!-- Boton para rechazar la reprogramacion -->
              <v-btn color="#FF5D34" 
               v-if="items.item.estado=='Pendiente Aprob. Reprog'"
              @click.prevent="rechazarReprogramacionJefeInmediato(items.item)" icon title="Rechazar">
                <v-icon>close</v-icon>
              </v-btn>
             
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import ReprogramarCronograma from "./dialogs/ReprogramarCronograma.vue";
import AprobarReprogramacionVacacion from "./dialogs/AprobarReprogramacionVacacion.vue";
import RechazarReprogramacionVacacion from "./dialogs/RechazarReprogramacionVacacion.vue";
import VerDetalle from "./dialogs/VerDetalleJefesRepro.vue";
import VerReporte from "./dialogs/VerReporte";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  // Variables iniciales del componente
  data() {
    let user = this.$storage.get("user");
    let id_persona = user.id_persona;
    return {
      url: "vVacacionReprogJefeJerarquicos",

      graphql: true,
      // Cabecera de la tabla
      headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        { text: "Nro", value: "secuencia", align: "center" },
        { text: "Nombre", value: "nombre", align: "center" },
        { text: "Fecha desde", value: "fecha_desde", align: "center" },
        { text: "Fecha hasta", value: "fecha_hasta", align: "center" },
        { text: "Días programados", value: "total_dias", align: "center" },
         { text: "Estado", value: "estado", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql:`
        id_estado
        secuencia
        fecha_desde
        fecha_hasta
        total_dias
        estado
        id_persona
        nombre
        id_vacacion_programada
        id_unidad
        nombre_unidad
        id_jefe
      `,
    
      initData: [
        {
          state: true,
          param: "id_jefe",
          value:  this.getIdPersona(),
        },
       
         {
          state: true,
          param: "lista_estados",
          value:  '"70,69,68,56,71"',
        },
      ],
      filters: [
        {
          field: "secuencia",
          label: "Nro",
          type: "number",
          typeG: "String"
        },
         {
          field: "nombre",
          label: "Nombre",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_desde",
          label: "Fecha salida",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_hasta",
          label: "Fecha fin",
          type: "text",
          typeG: "String"
        },

        {
          field: "total_dias",
          label: "Dias",
          type: "number",
          typeG: "String"
        },
        {
          field: "estado",
          label: "Estado",
          type: "text",
          typeG: "String"
        }
      ]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.onFilter();
    this.$bus.$on("closeDialogVerDetalleJefesRepro", () => {
      this.updateList();
    });
     this.$bus.$on("closeDialogSolicitarUsoVacacionFuncionario", () => {
      this.updateList();
    });
     this.$bus.$on("closeDialogReprogramacion", () => {
      this.updateList();
    });
  },
  // Métodos y funciones del componente
  methods: {
        getIdPersona(){
      const user = this.$storage.get('user');
      let usuario = user.id_persona;
      return usuario;  
    },
      getIdUnidad(){
      const user = this.$storage.get('user');
      let unidad = user.unidad[0].id;
      return unidad;  
    },

    aprobarReprogramacion(item) {
      this.$bus.$emit("openDialogAprobarReprogramacion", item);
    },
    reprogramarCronograma(item) {
      if (true) {
        this.$bus.$emit("openDialogReprogramarCronograma", item);
      } else {
        this.$confirm("Ya realizó la reprogramación", () => {});
      }
    },
    verDetalle(item) {
      this.$bus.$emit("openDialogVerDetalleJefesRepro", item);
    },
    rechazarReprogramacionJefeInmediato(item) {
     // this.$bus.$emit("openDialogRechazarProgramacionJefeInmediato", item);
    },
       verReporte(item, valor) {
      item.reprogramacion = valor;
      this.$bus.$emit("openDialogVerReporte", item);
    }
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    ReprogramarCronograma,
    VerDetalle,
    AprobarReprogramacionVacacion,
    RechazarReprogramacionVacacion,
     VerReporte,
  }
};
</script>

<style>
h3 {
  color: rgb(1, 3, 85);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_reprogramacion/VacacionReprogramacionJefeInmediato.vue